"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoverageIntegrationRun = void 0;
let CoverageIntegrationRun = exports.CoverageIntegrationRun = void 0;
(function (_CoverageIntegrationRun) {
  let Status = /*#__PURE__*/function (Status) {
    Status["DONE"] = "done";
    Status["ERROR"] = "error";
    Status["RUNNING"] = "running";
    return Status;
  }({});
  _CoverageIntegrationRun.Status = Status;
})(CoverageIntegrationRun || (exports.CoverageIntegrationRun = CoverageIntegrationRun = {}));